<template>
  <footer>
    <div class="container">
      <div class="row">
        <!-- useful links -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>Links Úteis</h4>
          <ul class="row footer-links">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <li><a href="/">Criação de Sites</a></li>
              <li><a href="/sobre">Sobre a Digiprod</a></li>
              <li><a href="/servicos">Serviços</a></li>
              <!-- <li><a href="#">Blog</a></li> -->
              <!-- <li><a href="#">Aplicativos Mobile</a></li> -->
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <li><a href="#">Organização</a></li>
              <li><a href="#">Suporte 24h</a></li>
              <li><a href="#">Cresça Certo</a></li>
              <!-- <li><a href="#">Carreira</a></li> -->
              <!-- <li><a href="#">Na Mídia</a></li> -->
            </div>
          </ul>
        </div>

        <!-- recent news -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <!-- <h4>Recent News</h4> -->

          <div class="row footer-news">
            <!-- <div class="col-md-4 col-sm-4 col-xs-6">
              <img
                src="assets/img/intro.jpg"
                class="img-responsive center-block"
                alt="recent news 1"
              />
            </div> -->
            <div class="col-md-8 col-sm-4 col-xs-6">
              <!-- <div class="row">
                <p class="text-capitalize">
                  <a href="#">
                    a clear website gives more experience to the visitors
                  </a>
                </p>
                <p class="news-date">Dec 12,2015</p>
              </div> -->
            </div>
          </div>
          <!-- /.footer-news -->

          <div class="row footer-news">
            <div class="col-md-4 col-sm-4 col-xs-6">
              <!-- <img
                src="assets/img/intro.jpg"
                class="img-responsive center-block"
                alt="recent news 2"
              /> -->
            </div>
            <div class="col-md-8 col-sm-4 col-xs-6">
              <!-- <div class="row">
                <p class="text-capitalize">
                  <a href="#">
                    a clear website gives more experience to the visitors
                  </a>
                </p>
                <p class="news-date">Dec 12,2015</p>
              </div> -->
            </div>
          </div>
          <!-- /.footer-news -->
        </div>
        <!-- /.footer-widget -->

        <!-- news-letter -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>Newsletter</h4>

          <p>Cadastre-se para receber atualizações e ofertas exclusivas.</p>
          <div class="input-group margin-bottom-sm">
            <input
              class="form-control"
              type="text"
              placeholder="Digite seu e-mail"
            />
            <span class="input-group-addon">
              <i class="fa fa-paper-plane fa-fw"></i>
            </span>
          </div>
          <p>Respeitamos sua privacidade.</p>
        </div>
        <!-- /.footer-widget -->

        <!-- about avada agency -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>DIGIPROD</h4>

          <p>
            A DIGIPROD conecta pessoas e empresas à era digital com automações,
            presença online e soluções de tecnologia acessíveis.
          </p>

          <div class="footer-address">
            <p>
              +55 (11) 91234-5678 <br />
              contato@digiprod.com.br
            </p>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ul class="footer-share-button">
                <li>
                  <a href="#"><i class="fa fa-twitter"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-google-plus"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-facebook"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-linkedin"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-youtube"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-pinterest"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-instagram"></i></a>
                </li>
              </ul>
              <!-- /.footer-share-button -->
            </div>
          </div>
        </div>
        <!-- /.footer-widget -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
};
</script>
